<template>
  <div>
    <h2>Groupes</h2>
    <div class="control">
      <div class="select">
        <select name="" class="genres" v-model="genre">
          <option value="">Tous les genres</option>
          <option v-for="genre in genres" :key="genre.id" :value="genre.nom">{{ genre.nom }}</option>
        </select>
        <select name="" class="tri-listes" v-model="liste">
          <option value="">Aucune liste</option>
          <option v-for="liste in listes" :key="liste.id" :value="liste.nom">{{ liste.nom }}</option>
        </select>
        <input type="text" v-model="search" placeholder="Rechercher..">
      </div>
      <div class="button">
        <a href="/#/addgroupe" class="add">Ajouter un groupe</a>
      </div>
    </div>
    <div class="display">
      <v-groupes  :token="token" :listes="listes" :liste="liste" :genre="genre" :search="search"></v-groupes>
    </div>
  </div>
</template>

<script>
import VGroupes from '../View/VGroupes'
import {settings} from '../../assets/settings'
export default {
  name: 'Groupes',
  components: {
    VGroupes
  },
  data () {
    return {
      genres: [],
      listes: [],
      liste: '',
      genre: '',
      token: '',
      search: ''
    }
  },
  methods: {
    getListes () {
      this.$http.get(settings.apiUrl + '/list/' + this.$parent.store.getToken()).then((response) => {
        this.listes = response.body.payload
      })
    },
    getGenres () {
      this.$http.get(settings.apiUrl + '/musickind/' + this.$parent.store.getToken()).then((response) => {
        this.genres = response.body.payload
      })
    }
  },
  mounted () {
    this.token = this.$parent.store.getToken()
    this.getListes()
    this.getGenres()
  }
}
</script>

<style scoped lang="scss">
.control {
  width: calc(100% - 30px);
  background-color: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: space-between;
  padding: 15px;
  .button {
    a {
      padding: 10px 10px;
      background-color: #175676;
      color: #fff;
      text-decoration: none;
      border-radius: 4px;
      display:block;
    }
  }
  .select {
    select {
      padding: 5px 0;
      border: none;
      color :#777;
      border-bottom: 1px solid #777;
      margin: 4.8px 20px 4.8px 0;
    }
  }
}
.display {
  width: calc(100% - 30px);
  background-color: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  height: calc(100vh - 280px);
  padding: 15px;
  margin-top: 20px;
  overflow-y: scroll;
}
input {
  border: none;
  border-bottom: solid 1px #adadad;
  font-size: 14px;
  padding: 5px;
}
  input:focus {
    border-bottom: solid 2px blue !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Page/Groupes.vue